import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { interval, Subscription, takeWhile } from 'rxjs';


@Component({
  selector: 'app-notification',
  imports: [MatSnackBarLabel, MatSnackBarModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnInit, OnDestroy {

  progress = 100;
  
  //durata di default se non fornita nei data
  private static readonly DEFAULT_DURATION_MS = 4000;

  //durata effettiva utilizzata nel componente
  private readonly durationMs: number;

  private sub?: Subscription;
 
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) 
    public data: {message: string; type: 'success' | 'error'; duration?: number},
    private readonly snackBarRef: MatSnackBarRef<NotificationComponent>
    ) {
    
    this.durationMs = (data && typeof data.duration === 'number' && data.duration > 0)
      ? data.duration
      : NotificationComponent.DEFAULT_DURATION_MS;
  }

  ngOnInit(): void {
    
    const tickMs = 100; //aggiornamento della progress bar ogni 100 ms
    const step = 100 / (this.durationMs / tickMs); //quantità in % da sottrarre ad ogni tickMs fino ad arrivare a 0 (cioè dopo durationMs millisecondi)  

    this.sub = interval(tickMs).pipe(takeWhile(() => this.progress > 0)).subscribe(() => {
      this.progress = Math.max(0, this.progress - step);
      if(this.progress <= 0) {
        this.close();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
  
  close(): void {
    this.sub?.unsubscribe();
    this.snackBarRef.dismiss();
  }

}
